import type { SettingsUpdateInput } from "@/modules/settings/domain/contracts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { settingsApi } from "./client";

export const settingsKeys = {
  all: ["settings"] as const,
  printContact: ["settings", "print-contact"] as const,
};

/** ເບີຮ້ານຈາກຕັ້ງຄ່າທົ່ວໄປ — ສຳລັບໃບພິມອໍເດີ (ຕ້ອງມີ orders:read) */
export function useOrderPrintContactQuery() {
  return useQuery({
    queryKey: settingsKeys.printContact,
    queryFn: () => settingsApi.getPrintContact(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useSettingsQuery() {
  return useQuery({
    queryKey: settingsKeys.all,
    queryFn: () => settingsApi.get(),
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SettingsUpdateInput) => settingsApi.update(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: settingsKeys.all });
      qc.invalidateQueries({ queryKey: settingsKeys.printContact });
    },
  });
}
